import React from 'react';
import clsx from 'clsx';
import { InformationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const VARIANTS = {
  info: {
    wrap: 'border-blue-200 bg-blue-50/90 dark:border-blue-500/30 dark:bg-blue-950/40',
    icon: 'text-blue-500',
    Icon: InformationCircleIcon,
  },
  warning: {
    wrap: 'border-amber-200 bg-amber-50/90 dark:border-amber-500/30 dark:bg-amber-950/40',
    icon: 'text-amber-500',
    Icon: ExclamationTriangleIcon,
  },
};

export default function SettingsInfoNotice({ variant = 'info', title, children }) {
  const style = VARIANTS[variant] || VARIANTS.info;
  const Icon = style.Icon;

  return (
    <div className={clsx('flex gap-3 rounded-xl border p-4', style.wrap)}>
      <Icon className={clsx('mt-0.5 h-5 w-5 shrink-0', style.icon)} />
      <div className="min-w-0 text-sm text-slate-700 dark:text-slate-300">
        {title ? <p className="mb-1 font-medium text-slate-900 dark:text-slate-50">{title}</p> : null}
        {children}
      </div>
    </div>
  );
}
